import Page from '../pages/model'
import api from '@/helpers/api'
import { saveQuestionItem, saveQuestionList } from '../../cache'

export default {
    state: {

    },

    mutations: {

    },

    getters: {

    },

    actions: {
        fetchItems (store, testId) {
            Page.dispatch('addLoader', 'questions.fetchItems')
            let params = {ActivityId: testId}

            return api.get('/api/v1/questions/GetByActivityId', {params})
            .then(res => {
                store.dispatch('insertOrUpdate', { data: res.data.data })
                saveQuestionList(res.data.data)
                return res
            }).finally(()=>{
                Page.dispatch('removeLoader', 'questions.fetchItems')
            })
        },
        fetchById(store, {testId, questionId}) {
            Page.dispatch('addLoader', 'questions.fetchById')
            let params = {ActivityId: testId, Id: questionId}

            return api.get(`/api/v1/questions/GetById`, {params})
            .then(res => {
                store.dispatch('insertOrUpdate', { data: res.data.data })
                saveQuestionItem(res.data.data)
                return res
            }).finally(()=>{
                Page.dispatch('removeLoader', 'questions.fetchById')
            })
        }
    }
}
